import { render, staticRenderFns } from "./CmgReferralLandingPage.vue?vue&type=template&id=1b792996&scoped=true&lang=pug"
import script from "./cmg-referral-landing-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-referral-landing-page.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgReferralLandingPage.vue?vue&type=style&index=0&id=1b792996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b792996",
  null
  
)

export default component.exports